module.exports = __webpack_public_path__ + "img/921_page_background_people3_pc.4bdc4222.jpg";